import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { APPS_FEATURE, RELEASES } from '../../../../../store/utils/files-names';
import { ReleaseModel } from '../../../models/release.model';

export const getAppReleasesSelector = (state: AppRootState): ReleaseModel[] =>
  get(state, `${APPS_FEATURE}.${RELEASES}`).releases;
